import _sfc_main from "./DatepickerPC.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "pickerRef", staticClass: "container" }, [_c(_setup.TuiInput, { staticClass: "datepicker-input", attrs: { "model-value": _setup.formattedDate, "readonly": "" }, on: { "input": function($event) {
    _setup.formattedDate = $event;
  }, "focus": _setup.togglePicker } }), _setup.showPicker ? _c("div", { staticClass: "picker" }, [_c("div", { staticClass: "picker-header" }, [_c("span", { staticClass: "current-time" }, [_vm._v(" " + _vm._s(_setup.currentYear) + "/" + _vm._s(_setup.currentMonth < 10 ? `0${_setup.currentMonth}` : _setup.currentMonth) + " ")]), _c("button", { staticClass: "arrow", on: { "click": function($event) {
    return _setup.changeMonth(-1);
  } } }, [_vm._v("<")]), _c("button", { staticClass: "arrow", on: { "click": function($event) {
    return _setup.changeMonth(1);
  } } }, [_vm._v(">")])]), _c("div", { staticClass: "picker-weekdays" }, _vm._l(_setup.weekdays, function(weekday) {
    return _c("div", { key: weekday, staticClass: "weekday" }, [_vm._v(" " + _vm._s(weekday) + " ")]);
  }), 0), _c("div", { staticClass: "picker-body" }, _vm._l(_setup.days, function(day) {
    return _c("div", { key: day.id, staticClass: "day", class: {
      "other-month": day.otherMonth,
      selected: _setup.isSelected(day.date),
      today: _setup.isToday(day.date),
      past: _setup.isPast(day.date)
    }, on: { "click": function($event) {
      return _setup.selectDate(day.date);
    } } }, [_vm._v(" " + _vm._s(day.label) + " "), _setup.isToday(day.date) ? _c("span", { staticClass: "today-dot" }) : _vm._e()]);
  }), 0)]) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "bfd37767"
);
const DatepickerPC = __component__.exports;
export {
  DatepickerPC as default
};
